(function () {
  'use strict';

  function formatEUR(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getBreaks() {
    try {
      var qb = window.quantity_break_data;
      if (!qb || !qb.data_settings) return null;
      var offer = qb.data_settings.offer;
      if (!offer || !offer.discounts) return null;
      return offer.discounts.quantity_breaks || null;
    } catch (e) {
      return null;
    }
  }

  function calcAndRender(box, discountPercent) {
    var basePrice = parseInt(box.dataset.basePrice, 10);
    var rolls = parseInt(box.dataset.rollsPerCarton, 10) || 1;
    if (isNaN(basePrice) || basePrice <= 0 || rolls <= 0) return;
    var perCarton = basePrice * (1 - discountPercent / 100);
    var perRoll = perCarton / rolls;
    var valueEl = box.querySelector('[data-pr-value]');
    if (valueEl) valueEl.textContent = formatEUR(perRoll);
  }

  function setInitial(box) {
    var breaks = getBreaks();
    if (!breaks) {
      calcAndRender(box, 0);
      return;
    }
    var def = null;
    for (var i = 0; i < breaks.length; i++) {
      if (breaks[i].isDefault) { def = breaks[i]; break; }
    }
    calcAndRender(box, def ? def.amount : 0);
  }

  function findMatchingBreak(text) {
    var breaks = getBreaks();
    if (!breaks || !text) return null;
    var bestMatch = null;
    var bestMatchLen = -1;
    for (var i = 0; i < breaks.length; i++) {
      var title = breaks[i].title;
      if (title && text.indexOf(title) >= 0 && title.length > bestMatchLen) {
        bestMatch = breaks[i];
        bestMatchLen = title.length;
      }
    }
    return bestMatch;
  }

  function init() {
    var box = document.querySelector('.preis-pro-rolle-box');
    if (!box) return;

    setInitial(box);

    document.addEventListener('click', function (e) {
      var xb = e.target.closest('#xboost-recommendation-root, .xboost-auto-add, [class*="xboost"], [class*="xb-"]');
      if (!xb) return;

      setTimeout(function () {
        var clicked = e.target.closest('label');
        var text = '';
        if (clicked) {
          text = clicked.textContent || '';
        } else {
          var up = e.target;
          for (var i = 0; i < 6 && up; i++, up = up.parentElement) {
            var t = up.textContent || '';
            var match = findMatchingBreak(t);
            if (match && t.length < 200) {
              calcAndRender(box, match.amount);
              return;
            }
          }
          return;
        }

        var matched = findMatchingBreak(text);
        if (matched) calcAndRender(box, matched.amount);
      }, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
